/* eslint-disable import/prefer-default-export */

export const imageWidth = (isLead, isWapView) => {
  let width;
  if (isWapView) {
    width = isLead ? 350 : 120;
  } else {
    width = isLead ? 500 : 300;
  }
  return width;
};

export const getSearchKeyword = urlPath => {
  let searchKeyword = '';
  if (urlPath) {
    const pathArr = urlPath.split('/');
    if (pathArr && pathArr.length > 0) {
      const detailsArr = pathArr.pop().split('-');
      if (detailsArr && detailsArr.length > 0) {
        searchKeyword = detailsArr.pop();
      }
    }
  }
  return searchKeyword;
};

export const getKeywordFromUrl = urlPath => {
  let searchKeyword = '';
  if (urlPath) {
    const str = urlPath.split('/').pop();
    if (str && str.length > 0) {
      if (str.includes('--')) {
        searchKeyword = str.split('--')[0];
      } else if (str === 'all-toi-stories') {
        searchKeyword = str;
      } else {
        const newArr = str.split('-');
        newArr.pop();
        searchKeyword = newArr.join('-');
      }
    }
  }
  return searchKeyword;
};

export const preloadLeadImage = (topStory, isWapView = false) => {
  let showPreload = false;
  const imageInfo = [];

  if (Array.isArray(topStory) && topStory.length > 0) {
    topStory.forEach(item => {
      imageInfo.push(
        `https://static.toiimg.com/thumb/imgsize-${item.image?.imagesize ||
          '123456'},msid-${item.image?.id},width-${imageWidth(
          item.isLead === 'featured',
          isWapView,
        )},resizemode-4/${item.image?.id}.jpg`,
      );
    });

    // imageInfo.push(`https://static.toiimg.com/photo/69822060.cms`);
    // imageInfo.push(`https://static.toiimg.com/photo/89937430.cms`);
    // if (isWapView) {
    //   imageInfo.push(`https://static.toiimg.com/photo/89937437.cms`);
    // }
    showPreload = imageInfo instanceof Array && imageInfo.length > 0;
  }
  return { showPreload, imageInfo };
};
